import PropTypes from 'prop-types';

export default {
  handleAccept: PropTypes.func,
  describedByID: PropTypes.string,
};
